import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// React
import React, { useCallback, useContext, useEffect, useState, useImperativeHandle } from 'react';

// Constants
import tenantCountryMapping from '../configurations/tenantCountryMapping.json';

// Libs
import i18n from '../i18n';
// MUI
import { Box, Grid, Typography } from '@mui/material';

//interfaces

//context
import { UserDetailsContext } from '../context/userContext';
import { CountryListDetailsContext } from '../context/countryContext';
import { ConsentDetailsContextV1 } from '../context/consentContextV1';
import { ConsentDetailsContextV2 } from '../context/consentContextV2';

//utils
import { getCountrySpecificFields, modifyFields, handleErr, cloneObject, generatePayloadObject, isEmpty, splitContactNumber, checkContactNumber, colSize, splitContactNumberWithISDCode } from '../utils/util';

// Constants
import { errorConstants } from '../configurations/settings';

//api
import { saveUserDetails } from '../api/saveUserDetails';
import { getUserConsentV1 } from '../api/getConsentV1';
import { getUserConsentV2 } from '../api/getConsentV2';

//components
import TextFieldComponent, { TextFieldsDisplay } from './textFieldComponent';
import AccordionComponent from './accordionComponent';
var RegisterUserDetails = function RegisterUserDetails(props, ref) {
  var _tenantCountryMapping, _countryListDetailsCo, _countryListDetailsCo2, _userData$user, _userData$user2;
  var countryListDetailsContext = useContext(CountryListDetailsContext);
  var tenantCountryCode = (_tenantCountryMapping = tenantCountryMapping.filter(function (tenant) {
    return tenant.tenantId.includes(String(props === null || props === void 0 ? void 0 : props.tenantId));
  })[0]) === null || _tenantCountryMapping === void 0 ? void 0 : _tenantCountryMapping.countryCode;
  var defaultCountryCode = props !== null && props !== void 0 && props.tenantId ? countryListDetailsContext === null || countryListDetailsContext === void 0 || (_countryListDetailsCo = countryListDetailsContext.countryData) === null || _countryListDetailsCo === void 0 || (_countryListDetailsCo = _countryListDetailsCo.filter(function (country) {
    return country.countryCode === tenantCountryCode;
  })[0]) === null || _countryListDetailsCo === void 0 ? void 0 : _countryListDetailsCo.countryCode : countryListDetailsContext === null || countryListDetailsContext === void 0 || (_countryListDetailsCo2 = countryListDetailsContext.countryData[0]) === null || _countryListDetailsCo2 === void 0 ? void 0 : _countryListDetailsCo2.countryCode;
  var _useContext = useContext(UserDetailsContext),
    userData = _useContext.userData,
    setUserDetailsFromInput = _useContext.setUserDetailsFromInput;
  var _useContext2 = useContext(ConsentDetailsContextV1),
    setConsentDetailsV1FromInput = _useContext2.setConsentDetailsV1FromInput;
  var _useContext3 = useContext(ConsentDetailsContextV2),
    setConsentDetailsV2FromInput = _useContext3.setConsentDetailsV2FromInput;
  var _useState = useState(getCountrySpecificFields(cloneObject(props === null || props === void 0 ? void 0 : props.displayFields), userData !== null && userData !== void 0 && (_userData$user = userData.user) !== null && _userData$user !== void 0 && _userData$user.countryCode ? userData === null || userData === void 0 || (_userData$user2 = userData.user) === null || _userData$user2 === void 0 ? void 0 : _userData$user2.countryCode : defaultCountryCode)),
    _useState2 = _slicedToArray(_useState, 2),
    userInfoFieldsState = _useState2[0],
    setUserInfoFieldsState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    displayError = _useState4[0],
    setDisplayError = _useState4[1];
  var errorDetails = [];
  var modifyUserFields = function modifyUserFields(fieldName, fieldValue, attributeName, validationFlag, validationMessage) {
    setUserInfoFieldsState(modifyFields(fieldName, fieldValue, attributeName, validationFlag, validationMessage, userInfoFieldsState));
  };
  var updateFieldValue = function updateFieldValue(name, value) {
    setUserDetailsFromInput(_objectSpread(_objectSpread({}, userData), {}, {
      user: _objectSpread(_objectSpread({}, userData.user), {}, _defineProperty({}, name, value))
    }));
  };
  useEffect(function () {
    var _userData$user3, _userData$user4, _countryListDetailsCo3;
    var tempDisplayFields = cloneObject(props === null || props === void 0 ? void 0 : props.displayFields);
    setUserInfoFieldsState(getCountrySpecificFields(tempDisplayFields, userData === null || userData === void 0 || (_userData$user3 = userData.user) === null || _userData$user3 === void 0 ? void 0 : _userData$user3.countryCode));
    if (userData !== null && userData !== void 0 && (_userData$user4 = userData.user) !== null && _userData$user4 !== void 0 && _userData$user4.countryCode && !isEmpty(countryListDetailsContext === null || countryListDetailsContext === void 0 || (_countryListDetailsCo3 = countryListDetailsContext.countryData) === null || _countryListDetailsCo3 === void 0 ? void 0 : _countryListDetailsCo3.find(function (country) {
      var _userData$user5;
      return country.countryCode === (userData === null || userData === void 0 || (_userData$user5 = userData.user) === null || _userData$user5 === void 0 ? void 0 : _userData$user5.countryCode);
    }))) {
      var _userData$user6;
      modifyUserFields('countrySelect', userData === null || userData === void 0 || (_userData$user6 = userData.user) === null || _userData$user6 === void 0 ? void 0 : _userData$user6.countryCode, 'isVisible', false, '');
    } else {
      modifyUserFields('countrySelect', defaultCountryCode, 'isVisible', false, '');
      setUserDetailsFromInput(_objectSpread(_objectSpread({}, userData), {}, {
        user: _objectSpread(_objectSpread({}, userData.user), {}, {
          'countryCode': props.regionCode === 'EU' ? '' : defaultCountryCode
        })
      }));
    }
  }, []);
  var getCountryNameFromCountryCode = function getCountryNameFromCountryCode(countryCodeValue) {
    if (countryCodeValue) {
      var _countryListDetailsCo4;
      var countryObjectValue = countryListDetailsContext === null || countryListDetailsContext === void 0 || (_countryListDetailsCo4 = countryListDetailsContext.countryData) === null || _countryListDetailsCo4 === void 0 ? void 0 : _countryListDetailsCo4.find(function (country) {
        return (country === null || country === void 0 ? void 0 : country.countryCode) === countryCodeValue;
      });
      return countryObjectValue === null || countryObjectValue === void 0 ? void 0 : countryObjectValue.countryName;
    } else {
      return '';
    }
  };
  var handleInputChange = function handleInputChange(event, regexPattern, fieldItem) {
    var value = event.target.value;
    value = value.trimStart();
    var name = event.target.name;
    if (regexPattern) {
      updateFieldValue(name, value);
      modifyUserFields(name, value, '', !new RegExp(regexPattern.source, regexPattern.flags).test(event.target.value), "".concat(i18n.t('REGISTRATION.IS_INVALID', {
        displayName: i18n.t(fieldItem.fieldLabel)
      })));
    } else {
      if (name === 'countrySelect') {
        var _countryListDetailsCo5;
        var countryCode = countryListDetailsContext === null || countryListDetailsContext === void 0 || (_countryListDetailsCo5 = countryListDetailsContext.countryData) === null || _countryListDetailsCo5 === void 0 || (_countryListDetailsCo5 = _countryListDetailsCo5.find(function (country) {
          return (country === null || country === void 0 ? void 0 : country.countryName) === value;
        })) === null || _countryListDetailsCo5 === void 0 ? void 0 : _countryListDetailsCo5.countryCode;
        setUserDetailsFromInput(_objectSpread(_objectSpread({}, userData), {}, {
          user: _objectSpread(_objectSpread({}, userData.user), {}, {
            'countryCode': value && countryCode ? countryCode : ''
          })
        }));
      } else {
        updateFieldValue(name, value);
      }
    }
  };
  var getOptionDisplay = function getOptionDisplay(fieldLabelName) {
    if (fieldLabelName === 'REGISTRATION.COUNTRY') {
      var _countryListDetailsCo6, _countryListDetailsCo7;
      return /*#__PURE__*/React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.regionCode) === 'EU' && /*#__PURE__*/React.createElement("option", {
        value: "",
        selected: true,
        disabled: true
      }, i18n.t('REGISTRATION.SELECT')), (!props.tenantId || (countryListDetailsContext === null || countryListDetailsContext === void 0 || (_countryListDetailsCo6 = countryListDetailsContext.countryData) === null || _countryListDetailsCo6 === void 0 ? void 0 : _countryListDetailsCo6.map(function (country) {
        return country.countryCode === tenantCountryCode;
      }))) && (countryListDetailsContext === null || countryListDetailsContext === void 0 || (_countryListDetailsCo7 = countryListDetailsContext.countryData) === null || _countryListDetailsCo7 === void 0 ? void 0 : _countryListDetailsCo7.map(function (country) {
        return /*#__PURE__*/React.createElement("option", {
          key: country === null || country === void 0 ? void 0 : country.countryId,
          value: country === null || country === void 0 ? void 0 : country.countryName
        }, country === null || country === void 0 ? void 0 : country.countryName);
      })));
    } else if (fieldLabelName === 'REGISTRATION.COUNTRY_CODE') {
      var _countryListDetailsCo8, _countryListDetailsCo9;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("option", {
        value: countryListDetailsContext === null || countryListDetailsContext === void 0 || (_countryListDetailsCo8 = countryListDetailsContext.countryData) === null || _countryListDetailsCo8 === void 0 || (_countryListDetailsCo8 = _countryListDetailsCo8.filter(function (country) {
          var _userData$user7;
          return (country === null || country === void 0 ? void 0 : country.countryName) === getCountryNameFromCountryCode(userData === null || userData === void 0 || (_userData$user7 = userData.user) === null || _userData$user7 === void 0 ? void 0 : _userData$user7.countryCode);
        })[0]) === null || _countryListDetailsCo8 === void 0 ? void 0 : _countryListDetailsCo8.isdCode
      }, countryListDetailsContext === null || countryListDetailsContext === void 0 || (_countryListDetailsCo9 = countryListDetailsContext.countryData) === null || _countryListDetailsCo9 === void 0 || (_countryListDetailsCo9 = _countryListDetailsCo9.filter(function (country) {
        var _userData$user8;
        return (country === null || country === void 0 ? void 0 : country.countryName) === getCountryNameFromCountryCode(userData === null || userData === void 0 || (_userData$user8 = userData.user) === null || _userData$user8 === void 0 ? void 0 : _userData$user8.countryCode);
      })[0]) === null || _countryListDetailsCo9 === void 0 ? void 0 : _countryListDetailsCo9.isdCode));
    } else {
      return '';
    }
  };
  var getFieldsDisplay = useCallback(function (item, index) {
    var _userData$user9, _userData$user10, _userData$user11, _userData$user12, _userData$user13, _userData$user14, _countryListDetailsCo10, _userData$user16, _props$environment;
    var contactSplitArr = splitContactNumber(userData === null || userData === void 0 || (_userData$user9 = userData.user) === null || _userData$user9 === void 0 ? void 0 : _userData$user9.contactNo);
    var fieldValue = '';
    switch (item.fieldName) {
      case 'firstName':
        fieldValue = userData === null || userData === void 0 || (_userData$user10 = userData.user) === null || _userData$user10 === void 0 ? void 0 : _userData$user10.firstName;
        break;
      case 'lastName':
        fieldValue = userData === null || userData === void 0 || (_userData$user11 = userData.user) === null || _userData$user11 === void 0 ? void 0 : _userData$user11.lastName;
        break;
      case 'emailId':
        fieldValue = userData === null || userData === void 0 || (_userData$user12 = userData.user) === null || _userData$user12 === void 0 ? void 0 : _userData$user12.emailId;
        break;
      case 'countrySelect':
        if (!(props !== null && props !== void 0 && props.tenantId) || (userData === null || userData === void 0 || (_userData$user13 = userData.user) === null || _userData$user13 === void 0 ? void 0 : _userData$user13.countryCode) === tenantCountryCode) fieldValue = String(getCountryNameFromCountryCode(userData === null || userData === void 0 || (_userData$user14 = userData.user) === null || _userData$user14 === void 0 ? void 0 : _userData$user14.countryCode));
        break;
      case 'countryCode':
        fieldValue = contactSplitArr[0] ? contactSplitArr[0] : countryListDetailsContext === null || countryListDetailsContext === void 0 || (_countryListDetailsCo10 = countryListDetailsContext.countryData) === null || _countryListDetailsCo10 === void 0 || (_countryListDetailsCo10 = _countryListDetailsCo10.filter(function (country) {
          var _userData$user15;
          return (country === null || country === void 0 ? void 0 : country.countryName) === getCountryNameFromCountryCode(userData === null || userData === void 0 || (_userData$user15 = userData.user) === null || _userData$user15 === void 0 ? void 0 : _userData$user15.countryCode);
        })[0]) === null || _countryListDetailsCo10 === void 0 ? void 0 : _countryListDetailsCo10.isdCode;
        break;
      case 'contactNo':
        fieldValue = checkContactNumber(contactSplitArr[1], userData === null || userData === void 0 || (_userData$user16 = userData.user) === null || _userData$user16 === void 0 ? void 0 : _userData$user16.contactNo);
        break;
      default:
        fieldValue = userData === null || userData === void 0 ? void 0 : userData.user[item.fieldName];
        break;
    }
    var environment = (_props$environment = props === null || props === void 0 ? void 0 : props.environment) !== null && _props$environment !== void 0 ? _props$environment : 'development';
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: colSize(item.colXsSize),
      sm: colSize(item.colLgSize),
      md: colSize(item.colLgSize),
      lg: colSize(item.colLgSize)
    }, item.isVisible && /*#__PURE__*/React.createElement(TextFieldComponent, {
      index: index,
      fieldItem: item,
      environment: environment,
      fieldValue: fieldValue,
      inputHandler: handleInputChange,
      blurHandlerWithRegex: handleInputChange,
      errorDetails: errorDetails,
      displayError: displayError,
      optionDisplay: getOptionDisplay
    }));
  }, [userInfoFieldsState, displayError, errorDetails]);
  var saveUserInfoDetails = function saveUserInfoDetails(reqObject, genericPayload, label) {
    saveUserDetails(reqObject, genericPayload).then(function (res) {
      var _res$data;
      props === null || props === void 0 || props.setLoader(false);
      props === null || props === void 0 || props.setSnackbar(true);
      props === null || props === void 0 || props.setSnackBarMessage(i18n.t('REGISTRATION.DETAILS_SAVED'));
      props === null || props === void 0 || props.setSnackBarSeverity('success');
      if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.userId) {
        if (label === i18n.t('REGISTRATION.SAVE')) {
          props === null || props === void 0 || props.setOpenRegisterModal(false);
          props === null || props === void 0 || props.cancelHandler();
        }
        if (label === i18n.t('REGISTRATION.NEXT')) {
          var _userData$user17;
          props === null || props === void 0 || props.handleActiveTab(2);
          getUserConsentV1(genericPayload).then(function (response) {
            setConsentDetailsV1FromInput(response.data);
          });
          getUserConsentV2(String(userData === null || userData === void 0 || (_userData$user17 = userData.user) === null || _userData$user17 === void 0 ? void 0 : _userData$user17.countryCode), genericPayload).then(function (response) {
            setConsentDetailsV2FromInput(response.data);
          });
        }
      }
    })["catch"](function (error) {
      var _error$response;
      props === null || props === void 0 || props.setLoader(false);
      if ((error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.error) === errorConstants.phoneNumberError) {
        var _error$response2;
        modifyUserFields('contactNo', reqObject.contactNo, '', true, error === null || error === void 0 || (_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 ? void 0 : _error$response2.message);
      } else {
        var _error$response$data$, _error$response3;
        props === null || props === void 0 || props.errorHandler({
          message: (_error$response$data$ = error === null || error === void 0 || (_error$response3 = error.response) === null || _error$response3 === void 0 || (_error$response3 = _error$response3.data) === null || _error$response3 === void 0 ? void 0 : _error$response3.message) !== null && _error$response$data$ !== void 0 ? _error$response$data$ : i18n.t('ERROR')
        });
      }
    });
  };
  useImperativeHandle(ref, function () {
    return {
      handleSaveAndNext: function handleSaveAndNext(label) {
        if (handleErr('', false, errorDetails).errorDetails.length === 0) {
          var _countryListDetailsCo11, _userData$user19, _userData$user20, _userData$user21, _userData$user22;
          var isdCode = countryListDetailsContext === null || countryListDetailsContext === void 0 || (_countryListDetailsCo11 = countryListDetailsContext.countryData) === null || _countryListDetailsCo11 === void 0 || (_countryListDetailsCo11 = _countryListDetailsCo11.filter(function (country) {
            var _userData$user18;
            return (country === null || country === void 0 ? void 0 : country.countryCode) === (userData === null || userData === void 0 || (_userData$user18 = userData.user) === null || _userData$user18 === void 0 ? void 0 : _userData$user18.countryCode);
          })[0]) === null || _countryListDetailsCo11 === void 0 ? void 0 : _countryListDetailsCo11.isdCode;
          var genericPayload = generatePayloadObject(props === null || props === void 0 ? void 0 : props.axiosInstance, props === null || props === void 0 ? void 0 : props.clientToken, props === null || props === void 0 ? void 0 : props.tenantId, props === null || props === void 0 ? void 0 : props.role, props === null || props === void 0 ? void 0 : props.requestorPayload, props === null || props === void 0 ? void 0 : props.dcsJwtToken);
          setDisplayError(false);
          var reqObject = userData.user;
          reqObject.firstName = userData === null || userData === void 0 || (_userData$user19 = userData.user) === null || _userData$user19 === void 0 ? void 0 : _userData$user19.firstName;
          reqObject.lastName = userData === null || userData === void 0 || (_userData$user20 = userData.user) === null || _userData$user20 === void 0 ? void 0 : _userData$user20.lastName;
          reqObject.contactNo = splitContactNumberWithISDCode(userData === null || userData === void 0 || (_userData$user21 = userData.user) === null || _userData$user21 === void 0 ? void 0 : _userData$user21.contactNo, isdCode);
          reqObject.countryCode = userData === null || userData === void 0 || (_userData$user22 = userData.user) === null || _userData$user22 === void 0 ? void 0 : _userData$user22.countryCode;
          props.setLoader(true);
          saveUserInfoDetails(reqObject, genericPayload, label);
        } else {
          setDisplayError(true);
        }
      }
    };
  });
  var headingSection = function headingSection(heading, desc) {
    return /*#__PURE__*/React.createElement(Box, {
      sx: {
        paddingTop: '18px',
        paddingBottom: '18px'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      sx: {
        fontWeight: 'bold'
      }
    }, i18n.t(heading)), /*#__PURE__*/React.createElement(Typography, {
      key: desc,
      component: "p",
      sx: {
        fontSize: '0.8rem'
      },
      color: "secondary.dark"
    }, i18n.t(desc ? desc : '')));
  };
  var contentSection = function contentSection(sections) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(TextFieldsDisplay, {
      fieldItem: sections,
      callback: getFieldsDisplay
    })));
  };
  var getDisplay = function getDisplay(fields) {
    return fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
      return !item.isAccordion ? /*#__PURE__*/React.createElement(React.Fragment, {
        key: item.sectionName
      }, headingSection(item.sectionName, item.description), contentSection(item.fields)) : /*#__PURE__*/React.createElement(React.Fragment, {
        key: item.sectionName
      }, /*#__PURE__*/React.createElement(AccordionComponent, {
        sections: item,
        index: index,
        environment: props === null || props === void 0 ? void 0 : props.environment,
        role: props === null || props === void 0 ? void 0 : props.role,
        headerCallback: headingSection,
        contentCallback: contentSection,
        type: "fieldType"
      }));
    });
  };
  return /*#__PURE__*/React.createElement(Box, null, getDisplay(userInfoFieldsState));
};
RegisterUserDetails.displayName = 'RegisterUserDetails';
var RegisterUserDetailsWrapper = /*#__PURE__*/React.forwardRef(RegisterUserDetails);
export default RegisterUserDetailsWrapper;